const getToday = () => {
  let today = new Date().toLocaleDateString('fa-IR' , { year: 'numeric', month: 'numeric', day: 'numeric' });
  const
    persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
    fixNumbers = function (str)
    {
      if(typeof str === 'string')
      {
        for(let i=0; i<10; i++)
        {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;
    };
  today = fixNumbers(today).split('/');

  return {
    year: today[0],
    month: today[1],
    day: today[2]
  }
}

const calculateAge = ({ year , month }) => {
  let today = getToday();
  const age = {
    year: 0,
    month: 0
  };

  age.year = today.year - year; // 1400 - 1398 = 2
  age.month = today.month - month; // 3 - 4 = -1
  if (age.month < 0) {
    age.year = age.year - 1; // 1
    age.month = 12 - (-(age.month)); // 12 - 1 = 11
  }
  return age;
}

export { getToday , calculateAge };